import type { TripRouteResponse } from '@/types/route';

function assignDefined(target: Record<string, unknown>, key: string, value: unknown) {
  if (value !== undefined && value !== null && value !== '') {
    target[key] = value;
  }
}

function assignRouteValue(target: Record<string, unknown>, key: string, value: unknown) {
  if (value !== undefined && value !== '') {
    target[key] = value;
  }
}

export function buildFleetTripPatchFromRoute(data: TripRouteResponse): Record<string, unknown> {
  const patch: Record<string, unknown> = {};
  const displayEta = data.eta_arrival_local || data.estimated_arrival || null;

  assignDefined(patch, 'eta_arrival_local', displayEta);
  assignDefined(patch, 'dashboard_eta_local', data.estimated_arrival);
  assignDefined(patch, 'estimated_arrival', displayEta);
  assignDefined(patch, 'destination_meeting_date', data.destination_meeting_date);
  assignRouteValue(patch, 'remaining_distance_km', data.route_remaining_km ?? data.remaining_distance_km);
  assignRouteValue(patch, 'route_remaining_km', data.route_remaining_km ?? data.remaining_distance_km);
  assignRouteValue(patch, 'route_remaining_min', data.route_remaining_min);
  assignRouteValue(patch, 'distance_traveled_km', data.route_traveled_km);
  assignRouteValue(patch, 'route_progress_pct', data.route_progress_percent);
  assignRouteValue(patch, 'total_route_km', data.route_total_km);
  assignRouteValue(patch, 'route_duration_min', data.duration_min);
  assignDefined(patch, 'eta_remaining_min', data.eta_remaining_min);
  assignDefined(patch, 'eta_source', data.eta_source);
  assignDefined(patch, 'dashboard_eta_remaining_min', data.eta_dashboard_remaining_min);
  assignDefined(patch, 'route_eta_remaining_min', data.eta_route_remaining_min);
  assignDefined(patch, 'eta_consistency_status', data.eta_consistency_status);
  assignDefined(patch, 'eta_consistency_diff_min', data.eta_consistency_diff_min);
  assignDefined(patch, 'is_at_destination', data.is_at_destination);
  assignDefined(patch, 'distance_to_destination_m', data.distance_to_destination_m);
  assignDefined(patch, 'customer', data.customer);
  assignDefined(patch, 'origin', data.origin_name);
  assignDefined(patch, 'destination_name', data.destination_name);
  assignDefined(patch, 'destination_lat', data.destination_lat);
  assignDefined(patch, 'destination_lon', data.destination_lon);
  assignDefined(patch, 'plate', data.plate);
  assignDefined(patch, 'economic', data.economic);
  assignDefined(patch, 'vehicle_type', data.vehicle_type);
  assignDefined(patch, 'brand', data.brand);
  assignDefined(patch, 'model', data.model);
  assignDefined(patch, 'vehicle_color', data.vehicle_color);
  assignDefined(patch, 'color', data.vehicle_color);

  return patch;
}

export function applyActiveRoutePatch<T extends Record<string, unknown>>(
  fleetData: T[],
  routeData: TripRouteResponse | null
): T[] {
  const routeAlias = String(routeData?.alias ?? '').trim();
  if (!routeAlias || fleetData.length === 0) return fleetData;

  const routePatch = buildFleetTripPatchFromRoute(routeData!);
  return fleetData.map((trip) => (
    String(trip?.alias ?? '').trim() === routeAlias
      ? { ...trip, ...routePatch }
      : trip
  ));
}
